import { render, staticRenderFns } from "./Cap.vue?vue&type=template&id=a84d95ec&scoped=true&"
import script from "./Cap.vue?vue&type=script&lang=js&"
export * from "./Cap.vue?vue&type=script&lang=js&"
import style0 from "./Cap.vue?vue&type=style&index=0&id=a84d95ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84d95ec",
  null
  
)

export default component.exports